import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { connect } from 'react-redux';
// import guide from '../../icons/guide.svg';
import arrow from '../../icons/arrow.svg';
import Config from '../../../../../Config';

function Links({ epiData }) {


    return (
        <div className="container-guide">
            {epiData.imageGuides.value?.url && <Image className='guide-icon' src={ Config.epiBaseUrl + epiData.imageGuides.value?.url} alt="guide-icon" />}
            {epiData?.guidesTitle && <div className='title'>{epiData?.guidesTitle}</div>}
            {epiData?.itemsGuides?.expandedValue?.map((item, index) => {
                const linkText = item.linkText?.value;
                const linkButton = item.linkButton?.value;
                return (
                    <div key={index} className="wrapper-links">
                        {linkButton && <a href={linkButton} target="_blank" rel="noopener noreferrer"> {linkText}</a>}
                        <Image className='arrow-icon' src={arrow} alt='icon' />
                    </div>
                );
            })}
        </div>
    );
}

const mapStateToProps = (state) => ({
    epiData: state.equipmentMinePage?.epiData,
});

export default connect(mapStateToProps)(Links);
